
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
    import dayjs from "dayjs";

    @Component
    export default class newDatePicker extends Vue {
        @Prop({ default: '' }) startDate!: string;
        @Prop({ default: '' }) endDate!: string;
        @Prop({ default: false }) readonly!: boolean;
        @Prop({ default: false }) isfocus!: boolean;
        startTime = dayjs(this.startDate).format('YYYY-MM-DD')
        endTime = dayjs(this.endDate).format('YYYY-MM-DD')

        currentDate = new Date()
        dateType = 0 // 时间选择器类型，1开始时间 2结束时间
        minDate = new Date(dayjs().subtract(10, 'year').format("YYYY-MM-DD")) // 默认10年前
        maxDate = new Date(dayjs().add(10, 'year').format("YYYY-MM-DD")) // 默认10年后

        @Watch('startDate')
        changeStartDate (val: string) {
            this.startTime = val
        }

        @Watch('endDate')
        changeEndDate (val: string) {
            this.endTime = val
        }

        /**
         * 限制“开始时间”不可比“结束时间”大，最长时间间隔不可超过一年。
         * @param val
         */
        @Watch('dateType')
        changeDateType (val: number) {
            if (this.dateType === 1) {
                if (!this.endTime) {
                    this.minDate = new Date(dayjs().subtract(10, 'year').format("YYYY-MM-DD")) // 默认10年前
                    this.maxDate = new Date(dayjs().add(10, 'year').format("YYYY-MM-DD")) // 默认10年后
                } else {
                    this.minDate = new Date(dayjs(this.endTime).subtract(1, 'year').format('YYYY-MM-DD'))
                    this.maxDate = new Date(this.endTime)
                }
                this.currentDate = new Date(this.startTime)
            } else if (this.dateType === 2) {
                if (!this.startTime) {
                    this.minDate = new Date(dayjs().subtract(10, 'year').format("YYYY-MM-DD")) // 默认10年前
                    this.maxDate = new Date(dayjs().add(10, 'year').format("YYYY-MM-DD")) // 默认10年后
                } else {
                    this.minDate = new Date(this.startTime)
                    this.maxDate = new Date(dayjs(this.startTime).add(1, 'year').format('YYYY-MM-DD'))
                }
                this.currentDate = new Date(this.endTime)
            }
        }


        changeType (type: number) {
            if (this.readonly) return;
            if (this.dateType === type) return
            this.dateType = type
            this.$emit('changeActive')
        }

        clearTime (type: number) {
            if (type === 1) {
                this.$emit('changeStartTime', '')
            } else if (type === 2) {
                this.$emit('changeEndTime', '')
            }
        }

        changeDate (e: any) {
            let val = e.getValues()
            if (this.dateType === 1) {
                this.$emit('changeStartTime', val.join('-'))
            } else if (this.dateType === 2) {
                this.$emit('changeEndTime', val.join('-'))
            }
        }

    }
